import useCoupon from 'hooks/useCoupon';
import useCustomer from 'hooks/useCustomer';

type UseInheritParamsType = {
  inheritParams: string;
};

const useInheritParams = (): UseInheritParamsType => {
  const { validCouponParam } = useCoupon();
  const { validCustomerParam } = useCustomer();

  const validParams: Array<string> = [];
  if (validCouponParam) {
    validParams.push(validCouponParam);
  }
  if (validCustomerParam) {
    validParams.push(validCustomerParam);
  }

  const inheritParams = validParams.join('&');

  return { inheritParams };
};

export default useInheritParams;
